import { bitTorrent } from 'viem/chains'
import type { Client } from '../../client'
import { createClient } from '../../client'
import type { Explorer } from '../../explorer'
import { createEtherscanV2 } from '../../explorer'
import type { Chain } from '../types/chain'
import type { HttpRpc } from '../types/rpc'

export const createBitTorrentChain = ({
  explorerApiKey: apiKey,
  explorerProxyUrl: proxyUrl,
  explorerPageSize: pageSize,
}: {
  explorerApiKey?: string
  explorerProxyUrl?: string
  explorerPageSize?: number
}): Chain =>
  createBitTorrentChainCustom({
    client: createClient({
      chain: bitTorrent,
      httpRpcs: bitTorrentHttpRpcs,
    }),
    explorer: createEtherscanV2({
      name: 'BTTCScan',
      baseUrl: 'https://bttcscan.com',
      chainId: 199,
      apiKey,
      proxyUrl,
      pageSize,
    }),
  })

type CreateBitTorrentChainCustomParameters = {
  client: Client
  explorer: Explorer
}

export const createBitTorrentChainCustom = ({
  client,
  explorer,
}: CreateBitTorrentChainCustomParameters): Chain => ({
  id: 199,
  network: 'bit-torrent',
  name: 'BitTorrent Chain',
  nativeToken: {
    name: 'BitTorrent',
    symbol: 'BTT',
    decimals: 18,
    currency: {
      symbol: 'BTT',
      type: 'CryptoCurrency',
      id: 'bittorrent',
      name: 'BitTorrent',
      updatedAt: 0,
    },
  },
  wrappedTokenAddresses: new Set([
    '0x23181f21dea5936e24163ffaba4ea3b316b57f3c',
  ]),
  explorer,
  client,
  blockTime: 2000,
  coingeckoId: 'bittorrent',
  defillamaId: undefined,
})

export const bitTorrentHttpRpcs: HttpRpc[] = [
  {
    url: 'https://rpc.bittorrentchain.io',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://rpc.bt.io',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
]

export const bitTorrentWebsocketRpcUrls: string[] = [
  'wss://bittorrent.drpc.org',
]
